export default __webpack_public_path__ + "static/media/campaign.af8ff51b.svg";